<template>
    <v-flex xs12 class="white">
        <v-tabs next-icon="mdi-arrow-right-bold-box-outline" icons-text prev-icon="mdi-arrow-left-bold-box-outline" show-arrows="show-arrows">
            <v-tabs-slider color="blue-grey darken-3"></v-tabs-slider>
            <v-tab ripple ><v-icon class="v-icon icon-home material-icons mr-2">insert_chart </v-icon> Informes</v-tab>
            <v-tab ripple ><v-icon class="v-icon icon-home material-icons mr-2">list </v-icon> Listar Pedidos</v-tab>
            <v-tab ripple ><v-icon class="v-icon icon-home material-icons mr-2">send </v-icon> Realizar Pedido</v-tab>
            <v-tab-item>
                <Informes />
            </v-tab-item>
            <v-tab-item>
                <ListarPedidos />
            </v-tab-item>
             <v-tab-item>
                <RealizarPedido/>
            </v-tab-item>
        </v-tabs>
    </v-flex>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import Informes from './Informes'
import ListarPedidos from'./ListarPedidos'
import RealizarPedido from './RealizarPedido'

export default {
    components:{
        Informes,
        ListarPedidos,
        RealizarPedido
    },

    async mounted() {
    },

    methods: {
        ...mapActions(['loadPedidosQueroTaxi', 'isClientQueroTaxi', 'loadUserLocal']),

    },

    computed: {
        ...mapState(['system'])
    }
}

</script>



// WEBPACK FOOTER //
// src/components/user/QueroTaxi/index.vue